import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from "sweetalert2";
import Select from "react-select";

const AddCase = ({ item, onAddCase }) => {
  const [formData, setFormData] = useState({
    cat_id: '',
    cat_name: '',
    cat_type: 'case',
    cat_type1: '',
    cat_type2: '',
    cat_status: '',
    par_cat_id: '',
    par_by: '',
    diagnosis: '',
    procedure: '',
    course_in_hospital: '',
    notes: '',
    clinical_history: '',
    physical_examination: '',
    general_examination: '',
    systematic_examination: '',
    advice: '',
    medicines: [], // NEW: Array to store medicines with dosages
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  });

  const [ldata, setLdata] = useState(null);
  const [activeTab, setActiveTab] = useState('diagnosis'); // Tab state
  const [medicineOptions, setMedicineOptions] = useState([]); // Medicine dropdown
  const [selectedMedicines, setSelectedMedicines] = useState([]); // Selected medicines with dosages
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Fetch medicine list from backend
  const fetchMedicineList = async () => {
    setLoading(true);
    try {
      const fd = new FormData();
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getMedListUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status && response.data.records) {
        const meds = response.data.records.map((m) => ({
          value: m.med_id,
          label: m.med_name,
        }));
        setMedicineOptions(meds);
      }
    } catch (err) {
      console.error("Error fetching medicines:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMedicineList();
  }, []);

  // Handle medicine selection
  const handleMedicineSelect = (selected) => {
    const withDosage = selected.map((s) => {
      const existing = selectedMedicines.find((m) => m.value === s.value);
      return existing ? existing : {
        ...s,
        morning: false,
        noon: false,
        evening: false,
        night: false,
      };
    });
    setSelectedMedicines(withDosage);

    setFormData((prev) => ({
      ...prev,
      medicines: withDosage.map((m) => ({
        med_id: m.value,
        med_name: m.label,
        morning: m.morning ? 1 : 0,
        noon: m.noon ? 1 : 0,
        evening: m.evening ? 1 : 0,
        night: m.night ? 1 : 0,
      })),
    }));
  };

  // Handle dosage checkbox change
  const handleDosageChange = (medId, dosageType, checked) => {
    const updated = selectedMedicines.map((m) =>
      m.value === medId ? { ...m, [dosageType]: checked } : m
    );
    setSelectedMedicines(updated);

    setFormData((prev) => ({
      ...prev,
      medicines: updated.map((m) => ({
        med_id: m.value,
        med_name: m.label,
        morning: m.morning ? 1 : 0,
        noon: m.noon ? 1 : 0,
        evening: m.evening ? 1 : 0,
        night: m.night ? 1 : 0,
      })),
    }));
  };

  // Remove medicine
  const handleRemoveMedicine = (medId) => {
    const updated = selectedMedicines.filter((m) => m.value !== medId);
    setSelectedMedicines(updated);

    setFormData((prev) => ({
      ...prev,
      medicines: updated.map((m) => ({
        med_id: m.value,
        med_name: m.label,
        morning: m.morning ? 1 : 0,
        noon: m.noon ? 1 : 0,
        evening: m.evening ? 1 : 0,
        night: m.night ? 1 : 0,
      })),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("cat_id", formData.cat_id);
    fd.append("cat_name", formData.cat_name);
    fd.append("cat_type", formData.cat_type);
    fd.append("cat_type1", formData.cat_type1);
    fd.append("cat_type2", formData.cat_type2);
    fd.append("cat_status", formData.cat_status);
    fd.append("par_cat_id", formData.par_cat_id);
    fd.append("par_by", ldata?.user_id || "");

    // rich text fields
    fd.append("diagnosis", formData.diagnosis || "");
    fd.append("procedure", formData.procedure || "");
    fd.append("course_in_hospital", formData.course_in_hospital || "");
    fd.append("notes", formData.notes || "");
    fd.append("clinical_history", formData.clinical_history || "");
    fd.append("physical_examination", formData.physical_examination || "");
    fd.append("general_examination", formData.general_examination || "");
    fd.append("systematic_examination", formData.systematic_examination || "");
    fd.append("advice", formData.advice || "");

    // NEW: Medicines data as JSON
    fd.append("medicines", JSON.stringify(formData.medicines));

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.addCatUrl,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const res = response.data;

      if (res.status) {
        Swal.fire({
          title: "Success!",
          text: res.success || "Case saved successfully.",
          icon: "success",
          confirmButtonColor: "#198754",
          timer: 2000,
          showConfirmButton: false,
        });

        const closeBtn = document.getElementById("closeCaseBtn");
        if (closeBtn) closeBtn.click();

        if (typeof onAddCase === "function") onAddCase();

        // Reset fields
        setFormData((prev) => ({
          ...prev,
          cat_name: "",
          diagnosis: "",
          procedure: "",
          course_in_hospital: "",
          notes: "",
          clinical_history: "",
          physical_examination: "",
          general_examination: "",
          systematic_examination: "",
          advice: "",
          medicines: [],
        }));
        setSelectedMedicines([]);
        setActiveTab('diagnosis');
      } else {
        Swal.fire({
          title: "Failed!",
          text: res.success || "Unable to save case.",
          icon: "error",
          confirmButtonColor: "#dc3545",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while saving.",
        icon: "error",
        confirmButtonColor: "#dc3545",
      });
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      setLdata(JSON.parse(storedData));
    }

    if (item) {
      setFormData((prev) => ({
        ...prev,
        cat_id: item.cat_id || "",
        cat_name: item.cat_name || "",
        cat_type: item.cat_type || "case",
        cat_type1: item.cat_type1 || "",
        cat_type2: item.cat_type2 || "",
        cat_status: item.cat_status || "",
        par_cat_id: item.par_cat_id || "",
        par_by: item.par_by || "",
        diagnosis: item.diagnosis || "",
        procedure: item.procedure || "",
        course_in_hospital: item.course_in_hospital || "",
        notes: item.notes || "",
        clinical_history: item.clinical_history || "",
        physical_examination: item.physical_examination || "",
        general_examination: item.general_examination || "",
        systematic_examination: item.systematic_examination || "",
        advice: item.advice || "",
      }));

      // Load medicines if editing
      if (item.medicines) {
        try {
          const meds = typeof item.medicines === 'string' ? JSON.parse(item.medicines) : item.medicines;
          const medicinesWithDosage = meds.map(m => {
            const opt = medicineOptions.find(o => o.value == m.med_id);
            return {
              value: opt ? opt.value : m.med_id,
              label: opt ? opt.label : m.med_name,
              morning: m.morning == 1,
              noon: m.noon == 1,
              evening: m.evening == 1,
              night: m.night == 1,
            };
          });
          setSelectedMedicines(medicinesWithDosage);
        } catch (e) {
          console.error("Error parsing medicines:", e);
        }
      }
    }
  }, [item, medicineOptions]);

  return (
    <div className="modal fade" id="showModalCase" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header bg-light p-3 d-flex justify-content-between align-items-center">
            <h5 className="modal-title" id="exampleModalLabel">Add Case</h5>
            <button type="button" className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn" data-bs-dismiss="modal" id="close-modal">
              Close
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Case Name</label>
                <input name="cat_name" onChange={handleChange} value={formData.cat_name}
                  className="form-control" placeholder="Enter case name" required />
              </div>

              {/* TABS NAVIGATION */}
              <ul className="nav nav-tabs mb-3" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'diagnosis' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('diagnosis')}
                  >
                    Diagnosis
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'procedure' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('procedure')}
                  >
                    Procedure
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'course' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('course')}
                  >
                    Course in Hospital
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'notes' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('notes')}
                  >
                    Notes
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'clinical' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('clinical')}
                  >
                    Clinical History
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'physical' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('physical')}
                  >
                    Physical Exam
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'general' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('general')}
                  >
                    General Exam
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'systematic' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('systematic')}
                  >
                    Systematic Exam
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'advice' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('advice')}
                  >
                    Advice
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === 'medicine' ? 'active' : ''}`}
                    type="button"
                    onClick={() => setActiveTab('medicine')}
                  >
                    Medicine
                  </button>
                </li>
              </ul>

              {/* TAB CONTENT */}
              <div className="tab-content">
                {activeTab === 'diagnosis' && (
                  <div className="mb-3">
                    <label className="form-label">DIAGNOSIS</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.diagnosis || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, diagnosis: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'procedure' && (
                  <div className="mb-3">
                    <label className="form-label">PROCEDURE</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.procedure || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, procedure: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'course' && (
                  <div className="mb-3">
                    <label className="form-label">COURSE IN HOSPITAL</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.course_in_hospital || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, course_in_hospital: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'notes' && (
                  <div className="mb-3">
                    <label className="form-label">NOTES</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.notes || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, notes: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'clinical' && (
                  <div className="mb-3">
                    <label className="form-label">CLINICAL HISTORY</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.clinical_history || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, clinical_history: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'physical' && (
                  <div className="mb-3">
                    <label className="form-label">PHYSICAL EXAMINATION</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.physical_examination || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, physical_examination: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'general' && (
                  <div className="mb-3">
                    <label className="form-label">GENERAL EXAMINATION</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.general_examination || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, general_examination: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'systematic' && (
                  <div className="mb-3">
                    <label className="form-label">SYSTEMATIC EXAMINATION</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.systematic_examination || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, systematic_examination: data }));
                      }}
                    />
                  </div>
                )}

                {activeTab === 'advice' && (
                  <div className="mb-3">
                    <label className="form-label">ADVICE</label>
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.advice || ""}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData(prev => ({ ...prev, advice: data }));
                      }}
                    />
                  </div>
                )}

                {/* NEW MEDICINE TAB */}
                {activeTab === 'medicine' && (
                  <div className="mb-3">
                    <label className="form-label">Select Medicines</label>
                    <Select
                      isMulti
                      options={medicineOptions}
                      isLoading={loading}
                      onChange={handleMedicineSelect}
                      value={selectedMedicines}
                      placeholder="Search and select medicines..."
                      className="mb-3"
                    />

                    {/* Selected Medicines with Dosage */}
                    {selectedMedicines.length > 0 && (
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th style={{ width: '40%' }}>Medicine Name</th>
                              <th className="text-center">Morning</th>
                              <th className="text-center">Noon</th>
                              <th className="text-center">Evening</th>
                              <th className="text-center">Night</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedMedicines.map((med) => (
                              <tr key={med.value}>
                                <td>{med.label}</td>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={med.morning || false}
                                    onChange={(e) => handleDosageChange(med.value, 'morning', e.target.checked)}
                                  />
                                </td>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={med.noon || false}
                                    onChange={(e) => handleDosageChange(med.value, 'noon', e.target.checked)}
                                  />
                                </td>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={med.evening || false}
                                    onChange={(e) => handleDosageChange(med.value, 'evening', e.target.checked)}
                                  />
                                </td>
                                <td className="text-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={med.night || false}
                                    onChange={(e) => handleDosageChange(med.value, 'night', e.target.checked)}
                                  />
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleRemoveMedicine(med.value)}
                                  >
                                    <i className="ri-delete-bin-line"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" id="closeCaseBtn" className="btn btn-light" data-bs-dismiss="modal">Close</button>
              <button type="submit" className="btn btn-success">
                {formData.cat_id ? 'Update' : 'Add'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCase;